import { T } from "../theme";

export default function PageHeader({ icon: Icon, iconColor = T.accent, title, description, children }) {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 32, flexWrap: "wrap", gap: 16 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
        {Icon && (
          <div
            style={{
              width: T.iconBoxSize,
              height: T.iconBoxSize,
              borderRadius: T.iconBoxRadius,
              background: `${iconColor}15`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Icon size={20} color={iconColor} />
          </div>
        )}
        <div>
          <h1
            style={{
              fontSize: T.titleSize,
              fontWeight: T.titleWeight,
              fontFamily: T.fontTitle,
              color: T.textHi,
              letterSpacing: "-0.03em",
              lineHeight: 1.2,
            }}
          >
            {title}
          </h1>
          {description && (
            <p style={{ fontSize: T.subtitleSize, fontWeight: 500, color: T.textLow, marginTop: 4 }}>
              {description}
            </p>
          )}
        </div>
      </div>
      {children && <div style={{ display: "flex", alignItems: "center", gap: 10 }}>{children}</div>}
    </div>
  );
}
